import { render, staticRenderFns } from "./AppointmentsDashboard.vue?vue&type=template&id=86ccb3a8&"
import script from "./AppointmentsDashboard.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports